import { api } from "aldoo-ra/API";

// Create API client for devops service - use aldoo-devops endpoint
const devopsAPI = api("aldoo-devops");

/**
 * Install content to a remote environment (upload)
 * @param {Object} params - Installation parameters
 * @param {Object} params.environment - Target environment { name, api, api_key }
 * @param {Object} params.content - Content to install { _id, name, type }
 * @param {Array} params.target - Dependency resolver target array
 * @param {string} params.mode - Installation mode: merge, update, skip, or replace
 * @param {Function} [onProgress] - Progress callback function
 * @returns {Promise<Object>} - API response with installation result
 */
export const UploadContentToEnvironment = async (params, onProgress) => {
    try {
        const response = await devopsAPI({
            run: {
                script: "update/environment-install-upload",
                env: {
                    contentName: params.content.name,
                    environmentName: params.environment.name,
                    environmentApi: params.environment.api,
                    environmentApiKey: params.environment.api_key,
                    target: params.target,
                    DB_MODE: params.DB_MODE,
                    FILE_MODE: params.FILE_MODE
                }
            }
        });

        return response;
    } catch (error) {
        throw error;
    }
};

/**
 * Download and install content from a remote environment
 * @param {Object} params - Installation parameters
 * @param {Object} params.environment - Source environment { name, api, api_key }
 * @param {Object} params.content - Content to download { _id, name, type }
 * @param {Array} params.target - Dependency resolver target array
 * @param {string} params.DB_MODE - Database mode: merge, update, skip, or replace
 * @param {string} params.FILE_MODE - File mode: skip or replace
 * @param {Function} [onProgress] - Progress callback function
 * @returns {Promise<Object>} - API response with installation result
 */
export const DownloadContentFromEnvironment = async (params, onProgress) => {
    try {
        const response = await devopsAPI({
            run: {
                script: "update/environment-content-download",
                env: {
                    environmentName: params.environment.name,
                    environmentApi: params.environment.api,
                    environmentApiKey: params.environment.api_key,
                    contentName: params.content.name,
                    target: params.target,
                    DB_MODE: params.DB_MODE,
                    FILE_MODE: params.FILE_MODE
                }
            }
        }, {
            onTaskProgress: onProgress
        });

        return response;
    } catch (error) {
        throw error;
    }
};

export default {
    UploadContentToEnvironment,
    DownloadContentFromEnvironment
};
